import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

interface ProfileProgressBarProps {
  completeCopy: string
  value: number
}

const ProfileProgressBar = ({ value, completeCopy }: ProfileProgressBarProps) => (
  <Stack sx={{ gap: 8 }}>
    <Stack sx={{ flexDirection: 'row', gap: 4 }}>
      {Array.from({ length: 4 }).map((_, i) => (
        <Box
          key={i}
          sx={{
            bgcolor: i < value ? 'primary.main' : 'neutral.light',
            borderRadius: '24px',
            height: 4,
            width: '100%',
          }}
        />
      ))}
    </Stack>
    <Text sx={{ color: 'text.secondary' }} variant="body2">
      {(value / 4) * 100}% {completeCopy}
    </Text>
  </Stack>
)

export default ProfileProgressBar
